import { FC, useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Formik, FormikHelpers } from "formik";
import { t } from "i18next";
import * as Yup from "yup";

import TableListUsersActivitys from "@/shared/components/organisms/TableListUsersActivitys";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { FiltersCalendar } from "@/shared/components/organisms/FiltersCalendar";
import TableListFestivos from "@/shared/components/organisms/TableListFestivos";
import { InputDropDownSpan } from "@/shared/components/atoms/InputDropDownSpan";
import TableListGrupos from "@/shared/components/organisms/TableListGrupos";
import { SelectColor } from "../../shared/components/organisms/SelectColor";
import TableListSalas from "@/shared/components/organisms/TableListSalas";
import TableListBonos from "@/shared/components/organisms/TableListBonos";
import { SelectAvatar } from "@/shared/components/organisms/SelectAvatar";
import { CheckBoxDays } from "../../shared/components/atoms/CheckBoxDays";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import TableListKPIS from "@/shared/components/organisms/TableListKPIS";
import { InputFilepdf } from "@/shared/components/atoms/InputFilePDF";
import { Calendar } from "@/shared/components/organisms/Calendar";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { InputFile } from "@/shared/components/atoms/InputFile";
import { Select } from "@/shared/components/organisms/Select";
import { BaseEvent } from "@/app/events/events";
import { toasts } from "@/shared/utils/toasts";
import { colors, currencies } from "@/app/fees/fees";

import { selectBranch } from "@/app/branchs/branch.slice";

import {
  useRoomsQuery,
  useCreateRoomMutation,
  useDeleteRoomMutation,
  useUpdateRoomMutation,
} from "@/app/rooms/rooms.api";
import { useSpecialistsQuery } from "@/app/branchs/branchs.api";

import { useDeleteLessonProfessionalServiceMutation } from "@/app/lessons/lessons.api";

import {
  createRoomInitialValues,
  createRoomValidationSchema,
  CreateRoomValues,
} from "@/shared/schemas/rooms.schema";

import {
  bondInitialValues,
  bondValidationSchema,
  CreateBondValues,
} from "@/shared/schemas/bonds.schema";

import {
  holidaysInitialValues,
  holidaysValidationSchema,
  LessonTimesValues,
  assistedsTimesInitialValues,
  assistedsTimesValidationSchema,
  lessonProfessionalServiceValidationSchema,
  lessonProfessionalServiceInitialValues,
} from "@/shared/schemas/lessons.schema";

import {
  useActivateDeactivateBondMutation,
  useCreateBondMutation,
  useUpdateBondMutation,
} from "@/app/bonds/bonds.api";
import { useFeesMutation } from "@/app/fees/fees.api";

import {
  useAssistedsQuery,
  useCreateAssistedMutation,
  useEnrollAssistedMutation,
  useGetGroupAssistedQuery,
  useGetListBondAssistedQuery,
  useGetListBondModalQuery,
  useGetListGroupBondAssistedQuery,
  useKpiProfessionalServicesQuery,
  useUpdateAssistedGroupMutation,
  useUpdateAssistedMutation,
} from "@/app/assisteds/assisteds.api";
import {
  useCreateHolidayMutation,
  useDeleteHolidayMutation,
  useHolidaysQuery,
  useUpdateHolidayMutation,
} from "@/app/holidays/holidays.api";

import { useUpdateHoursMutation } from "@/app/branchs/branchs.api";
import { Modal } from "@/shared/components/organisms/Modal";
import { Input } from "@/shared/components/atoms/Input";
import { DOMAIN } from "@/app/app.api";
import { InputWithSelectHint } from "@/shared/components/atoms/InputWithSelectHint";
import { useFunctionDebounce } from "@/shared/hooks/debounce";
import { useFetchUsersMutation } from "@/app/users/users.api";
import { FIELD_REQUIRED_MESSAGE } from "@/shared/utils/validations";
import { Permission, usePermission } from "@/shared/hooks/usePermission";

const optionSelectFestivos = [
  { id: "Local", name: "Local" },
  { id: "Provincial", name: "Provincial" },
  { id: "Nacional", name: "Nacional" },
  { id: "Mundial", name: "Mundial" },
];

const optionColor = [
  { id: 1, color: "#A7BED3" },
  { id: 2, color: "#C6E2E9" },
  { id: 3, color: "#F1FFC4" },
  { id: 4, color: "#FFCAAF" },
  { id: 5, color: "#DAB894" },
  { id: 6, color: "#FF7477" },
  { id: 7, color: "#E69597" },
  { id: 8, color: "#CEB5B7" },
  { id: 9, color: "#B5D6D6" },
  { id: 10, color: "#9CF6F6" },
];

type BonosProps = {
  id: number | string;
  group: string;
  name: string;
  description: string;
  session: string;
  price: string;
  days: string;
  state: string;
  status: number;
  groupbond: {
    name: string;
  };
};

export const ServiciosProfesionales: FC<any> = () => {
  const { id } = useParams();
  const { can } = usePermission();
  const branch = useSelector(selectBranch);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));
  const [checkAllEvents, setCheckAllEvents] = useState(false);
  const [assistedsTimesValues, setAssistedsTimesValues] = useState({
    type: "assisteds",
    hours: 0,
    assisted_anticipation_days: 0,
    assisted_time_access: 0,
  });

  const [
    startDateKPIProfessionalServices,
    setStartDateKPIProfessionalServices,
  ] = useState(DateTime.now().startOf("month").toFormat("dd/MM/yyyy"));

  const [endDateKPIProfessionalServices, setEndDateKPIProfessionalServices] =
    useState(DateTime.now().toFormat("dd/MM/yyyy"));

  useEffect(() => {
    if (branch) {
      setAssistedsTimesValues({
        ...assistedsTimesValues,
        hours: branch.cancellation_assisteds,
        assisted_anticipation_days: branch.assisted_anticipation_days,
        assisted_time_access: branch.assisted_time_access,
      });
    }
  }, [branch]);

  //OPEN MODAL SALAS
  const [openModalSala, setOpenModalSala] = useState(false);
  const functionOpenModalSala = () => {
    setOpenModalSala(!openModalSala);
  };
  //OPEN FOR FILTERS
  const [filters, setFilters] = useState(false);
  const filtersOpen = () => {
    setFilters(!filters);
  };
  //OPEN DIALOG CREATE
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const functionOpenDialogCreate = () => {
    setOpenDialogCreate(!openDialogCreate);
  };
  //USE STATE SELECT CALENDAR
  const [selectCalendar, setSelectCalendar] = useState("Mes");
  const handleViewChange = (select: string) => {
    setSelectCalendar(select);
  };
  //ONDATE CHANGE
  const handleDateChange = (startDate: Date, endDate: Date) => {
    setStartDateKPIProfessionalServices(
      DateTime.now().startOf("month").toFormat("dd/MM/yyyy")
    );
    setEndDateKPIProfessionalServices(
      DateTime.fromJSDate(endDate).toFormat("dd/MM/yyyy")
    );
  };
  //OPEN DIALOG TIEMPOS
  const [openDialogTime, setOpenDialogTime] = useState(false);
  const functionOpenDialogTime = () => {
    setOpenDialogTime(!openDialogTime);
  };
  //OPEN DIALOG UPCALENDAR
  const [openDialogUpCalendar, setOpenDialogUpCalendar] = useState(false);
  const functionOpenDialogUpCalendar = () => {
    setOpenDialogUpCalendar(!openDialogUpCalendar);
  };
  //OPEN MODAL FESTIVOS
  const [openModalFestivos, setOpenModalFestivos] = useState(false);
  const functionOpenModalFestivos = () => {
    setOpenModalFestivos(!openModalFestivos);
  };
  //OPEN DIALOG FESTIVOS
  const [openDialogFestivos, setOpenDialogFestivos] = useState(false);
  const functionOpenDialogFestivos = () => {
    setOpenDialogFestivos(!openDialogFestivos);
  };
  //OPEN DIALOG CREATE SALAS
  const [openDialogSala, setOpenDialogSala] = useState(false);
  const functionOpenDialogSala = () => {
    setOpenDialogSala(!openDialogSala);
  };
  //OPEN MODAL GRUPOS
  const [openModalGrupos, setOpenModalGrupos] = useState(false);
  const functionOpenModalGrupos = () => {
    setOpenModalGrupos(!openModalGrupos);
  };

  //OPEN MODAL ACTIVIDADES
  const [openModalActividades, setOpenModalActividades] = useState(false);
  const functionOpenModalActividades = () => {
    setOpenModalActividades(!openModalActividades);
  };
  //SELECT COLOR
  const [selectColor, setSelectColor] = useState(optionColor[0]);
  //OPEN DIALOG CREATE GRUPOS
  const [openDialogCreateGrupos, setOpenDialogCreateGrupos] = useState(false);
  const functionOpenDialogCreateGrupos = () => {
    setOpenDialogCreateGrupos(!openDialogCreateGrupos);
  };
  //OPEN DIALOG EDIT GRUPOS
  const [openDialogEditGrupos, setOpenDialogEditGrupos] = useState(false);
  const functionOpenDialogEditGrupos = () => {
    setOpenDialogEditGrupos(!openDialogEditGrupos);
  };
  //OPEN MODAL BONOS
  const [openModalBonos, setOpenModalBonos] = useState(false);
  const functionOpenModalBonos = () => {
    setOpenModalBonos(!openModalBonos);
  };
  //OPEN DIALOG CREATE BONOS
  const [openDialogCreateBonos, setOpenDialogCreateBonos] = useState(false);
  const functionOpenDialogCreateBonos = () => {
    setOpenDialogCreateBonos(!openDialogCreateBonos);
  };
  //CHECKED BONOS
  const [checkedBonos, setCheckedBonos] = useState(false);
  //SELECT DIVISA
  //CHECKED BONO CENTRO DEPORTIVO
  const [checkedBonoCentroDeportivo, setCheckedBonoCentroDeportivo] =
    useState(false);
  const handleCheckedBonoCentroDeportivo = () => {
    setCheckedBonoCentroDeportivo(!checkedBonoCentroDeportivo);
  };
  //CHECKED ACUMULAR SESSIONES
  const [checkedAcumular, setCheckedAcumular] = useState(false);
  const handleCheckedAcumular = () => {
    setCheckedAcumular(!checkedAcumular);
  };

  //USE STATE OPEN KPIS
  const [openKpis, setOpenKpis] = useState(false);
  const handleOpenKpis = () => {
    setOpenKpis(!openKpis);
  };
  //SELECT BONOS MODAL
  const [selectBonosModal, setSelectBonosModal] = useState([]);
  //OPEN MODAL DELETE EVENT
  const [openModalDeleteEvent, setOpenModalDeleteEvent] = useState(false);
  const [deleteAllEvents, setDeleteAllEvents] = useState(false);
  const functionOpenModalDeleteEvent = () => {
    setOpenModalDeleteEvent(!openModalDeleteEvent);
  };

  const groupListBondAssistedQuery = useGetListGroupBondAssistedQuery({
    branchId: id,
  });
  const listBondModalQuery = useGetListBondModalQuery({ branchId: id });
  const groupAssistedQuery = useGetGroupAssistedQuery({ branchId: id });
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [activateDeactivateBond] = useActivateDeactivateBondMutation();

  const assistedsQuery = useAssistedsQuery({
    branchId: id,
    groups: selectedGroups.map((group) => group.name),
    month,
  });

  const dataKpiProfessionalServicesQuery = useKpiProfessionalServicesQuery({
    branchId: id,
    startDate: startDateKPIProfessionalServices,
    endDate: endDateKPIProfessionalServices,
    groupBondIds: selectBonosModal.map((bono) => bono.id),
  });
  const [enrollUserAssisted, enrollUserAssistedResult] =
    useEnrollAssistedMutation();
  const [
    deleteLessonProfessionalService,
    deleteLessonProfessionalServiceResult,
  ] = useDeleteLessonProfessionalServiceMutation();

  const listBondAssistedQuery = useGetListBondAssistedQuery({ branchId: id });
  const [currentBondEdit, setCurrentBondEdit] = useState<
    (BonosProps & { divisa?: string }) | undefined
  >();
  const [createBond, createBondResult] = useCreateBondMutation();
  const [updateBond, updateBondResult] = useUpdateBondMutation();

  const [updateAssistedGroup, updateAssistedGroupResult] =
    useUpdateAssistedGroupMutation();
  const [fetchUsers] = useFetchUsersMutation();
  const roomsQuery = useRoomsQuery({ branchId: id });
  const [createRoom, createRoomResult] = useCreateRoomMutation();
  const [updateRoom, updateRoomResult] = useUpdateRoomMutation();
  const [deleteRoom] = useDeleteRoomMutation();

  const [currentGroupEdit, setCurrentGroupEdit] = useState(null);
  const [getterFees, getterFeesResult] = useFeesMutation();
  const specialistsQuery = useSpecialistsQuery({ branchId: id });

  useEffect(() => {
    if (id) {
      getterFees({
        branchId: id,
      });
    }
  }, [id]);

  const [currentRoomEdit, setCurrentRoomEdit] = useState();
  const [currentEventEdit, setCurrentEventEdit] = useState<
    BaseEvent | undefined
  >();
  const [currentEvent, setCurrentEvent] = useState<BaseEvent | undefined>();
  const [openModalEnrollUserActivity, setOpenModalEnrollUserActivity] =
    useState(false);
  const functionOpenModalEnrollUserActivity = () => {
    setOpenModalEnrollUserActivity(!openModalEnrollUserActivity);
  };
  const [createLesson, createLessonResult] = useCreateAssistedMutation();
  const [updateLesson, updateLessonResult] = useUpdateAssistedMutation();

  const [users, setUsers] = useState([]);
  const debouncedFetchDataUsers = useFunctionDebounce(fetchDataUsers, 300);
  //Fetch data users
  async function fetchDataUsers(search: string) {
    try {
      const response = await fetchUsers({
        search: search.length < 1 ? undefined : search,
        page: 1,
        limit: 20,
        branch: id,
      }).unwrap();

      const arrayUsers = [];
      let objetCompanies = {};

      for (let i = 0; i < response.data.length; i++) {
        objetCompanies = {
          id: response.data[i].id,
          name: response.data[i].name,
          email: response.data[i].email,
        };
        arrayUsers.push(objetCompanies);
      }
      setUsers(arrayUsers);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setOpenDialogCreate(!!currentEventEdit);
  }, [currentEventEdit]);

  useEffect(() => {
    if (createLessonResult.isSuccess) {
      setOpenDialogCreate(false);
      createLessonResult.reset();
    }
  }, [createLessonResult]);

  useEffect(() => {
    if (createRoomResult.isSuccess) {
      setOpenDialogSala(false);
    }
  }, [createRoomResult]);

  useEffect(() => {
    if (updateRoomResult.isSuccess) {
      setOpenDialogSala(false);
    }
  }, [updateRoomResult]);

  const handleEventClick = (event: BaseEvent) => {
    setCurrentEvent(event);
  };

  const [updateBranchHours, updateBranchHourssResult] =
    useUpdateHoursMutation();

  useEffect(() => {
    if (updateBranchHourssResult.isSuccess) {
      toasts.success(
        "Actualización exitosa",
        "Los tiempos se han actualizado correctamente"
      );
    }
    if (updateBranchHourssResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar los tiempos"
      );
    }
  }, [updateBranchHourssResult]);

  const holidaysQuery = useHolidaysQuery({ branchId: id });
  const [currentHolidayEdit, setCurrentHolidayEdit] = useState<any>();
  const [createHoliday, createHolidayResult] = useCreateHolidayMutation();
  const [updateHoliday, updateHolidayResult] = useUpdateHolidayMutation();
  const [deleteHoliday] = useDeleteHolidayMutation();

  const handleUpdateBond = async (bond: CreateBondValues) => {
    try {
      await updateBond({
        branchId: id,
        id: currentBondEdit?.id,
        name: bond.name,
        price: bond.price,
        currency: bond.currency,
        session: bond.session,
        daysCaducity: bond.daysCaducity,
        maxSession: bond.maxSession,
        name_group_bond: bond.name_group_bond,
        groupBondId: bond.groupBondId,
        description: bond.description,
      }).unwrap();

      toasts.success(
        "Actualización exitosa",
        "El bono se ha actualizado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar el bono"
      );
    }
  };

  const handleCreateBond = async (bond: CreateBondValues) => {
    try {
      console.info(
        "values to send to create bond",
        JSON.stringify({
          ...bond,
          branchId: id,
        })
      );
      await createBond({ ...bond, branchId: id }).unwrap();
      toasts.success("Registro exitoso", "El bono se ha creado correctamente");
    } catch (error) {
      toasts.danger("Error al crear", "Ha ocurrido un error al crear el bono");
    }
  };

  const handleActivateDeactivateBond = async (bondId: string) => {
    try {
      await activateDeactivateBond({ branchId: id, bondId: bondId }).unwrap();
      toasts.success(
        "Actualización exitosa",
        "El bono se ha actualizado correctamente"
      );
      functionOpenModalBonos();
      listBondModalQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar el bono"
      );
    }
  };

  const handleDeleteLessonProfessionalService = async () => {
    try {
      await deleteLessonProfessionalService({
        id: currentEvent?.id,
        branchId: id,
        all: deleteAllEvents,
      });
      assistedsQuery.refetch();
      functionOpenModalDeleteEvent();
      setCurrentEvent(undefined);
      setDeleteAllEvents(false);
      if (deleteAllEvents) {
        toasts.success(
          "Servicios profesionales eliminados",
          "Los servicios profesionales se han eliminado correctamente"
        );
        return;
      }

      toasts.success(
        "Servicio profesional eliminado",
        "El servicio profesional se ha eliminado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al eliminar",
        "Ha ocurrido un error al eliminar el servicio profesional"
      );
    }
  };

  const handleUpdateRoom = async (room: CreateRoomValues) => {
    try {
      await updateRoom({ ...room, id: currentRoomEdit.id });
      toasts.success(
        "Actualización exitosa",
        "La sala se ha actualizado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar la sala"
      );
      throw error;
    }
  };

  const handleCreateRoom = async (room: CreateRoomValues) => {
    try {
      await createRoom({ ...room, branchId: id });
      toasts.success("Creación exitosa", "La sala se ha creado correctamente");
    } catch (error) {
      toasts.danger("Error al crear", "Ha ocurrido un error al crear la sala");
      throw error;
    }
  };

  const handleEnrollUserActivity = async (values: any) => {
    try {
      const response = await enrollUserAssisted({
        assistedId: currentEvent?.id,
        userId: values.user,
      }).unwrap();

      if (response.error) {
        throw response.error;
      }

      setCurrentEvent(undefined);
      functionOpenModalEnrollUserActivity();
    } catch (error) {
      const message = error as string;

      if (message) {
        toasts.danger("Error al inscribir", message);
        throw error;
      }

      toasts.danger(
        "Error al inscribir",
        "Ha ocurrido un error al inscribir al usuario"
      );
      throw error;
    }
  };

  const handleClearKpis = () => {
    setSelectBonosModal([]);
    handleDateChange(DateTime.now().toJSDate(), DateTime.now().toJSDate());
  };

  const currentEventData = assistedsQuery?.data?.filter(
    (assisted: any) => assisted.name === currentEventEdit?.name
  );
  const lastEvent = currentEventData?.[currentEventData.length - 1];
  const firstEvent = currentEventData?.[0];

  const bondGroups = useMemo(() => {
    const groups =
      listBondModalQuery.data?.map((groupBond) => ({
        id: groupBond?.groupbond?.id, // 👈 aquí va el id
        name: groupBond?.groupbond?.name,
        groupbond: { name: groupBond?.groupbond?.name },
      })) ?? [];

    const unique = [
      ...new Map(groups.map((item) => [item.id, item])).values(), // 👈 clave única por id
    ];

    return unique.filter((item) => Boolean(item?.name));
  }, [listBondModalQuery?.data]);

  console.log("bondGroups", bondGroups);

  return (
    <div className="flex flex-col items-center h-full w-full p-2">
      <div className="flex flex-col w-full h-full">
        <Calendar
          functionButtonTime={functionOpenDialogTime}
          filtersOpen={filtersOpen}
          onEventClick={handleEventClick}
          functionButtonTopCreate={functionOpenDialogCreate}
          events={assistedsQuery?.data ?? []}
          loading={assistedsQuery.isLoading || assistedsQuery.isFetching}
          initialDateTime={DateTime.now()}
          functionOpenModalFestivos={functionOpenModalFestivos}
          functionOpenModalSala={functionOpenModalSala}
          onMonthChange={(date) => {
            setMonth(date.toFormat("yyyy-MM"));
            assistedsQuery.refetch();
          }}
          functionOpenModalGrupos={functionOpenModalGrupos}
          functionOpenModalActividades={functionOpenModalActividades}
          functionOpenModalBonos={functionOpenModalBonos}
          funcionOpenKpis={handleOpenKpis}
          canSeeKpis={can(
            Permission.BRANCH_ACCESS_VIEW_KPI_PROFESSIONAL_SERVICE_SALES_BY_STAFF
          )}
          canCreateActivity={can(
            Permission.BRANCH_ACCESS_CREATE_PROFESSIONAL_SERVICES
          )}
          canEditTimesActivity={can(
            Permission.BRANCH_ACCESS_EDIT_TIMES_IN_PROFESSIONAL_SERVICES
          )}
          canEditHolidaysActivity={can(
            Permission.BRANCH_ACCESS_EDIT_HOLIDAYS_IN_PROFESSIONAL_SERVICES
          )}
          canUploadCalendar={false}
        />

        {/*DIALOG CREATE/EDIT DISPONIBILIDADAD */}
        <Formik
          enableReinitialize
          validationSchema={lessonProfessionalServiceValidationSchema}
          initialValues={
            currentEventEdit
              ? {
                  roomId: currentEventEdit.roomId,
                  userId: currentEventEdit.userId,
                  groupId: currentEventEdit.groupId || null,
                  fees: currentEventEdit.fees,
                  capacity: currentEventEdit.capacity,
                  color: currentEventEdit.color,
                  meeting: currentEventEdit.meeting,
                  day: currentEventEdit.day,
                  days: currentEventEdit.days,
                  name: currentEventEdit.name,
                  startDate: checkAllEvents
                    ? firstEvent.date
                    : currentEventEdit.date,
                  endDate: checkAllEvents
                    ? lastEvent.date
                    : currentEventEdit.date,
                  startTime: currentEventEdit.startTime,
                  duration: currentEventEdit.duration,
                  meeting: currentEventEdit.meeting,
                }
              : lessonProfessionalServiceInitialValues
          }
          validateOnMount
          validateOnBlur
          validateOnChange
          isInitialValid
          onSubmit={async (values, formikHelpers) => {
            try {
              const feesValue = Array.isArray(values.fees)
                ? values.fees.join(",")
                : values.fees;

              if (currentEventEdit) {
                await updateLesson({
                  ...values,
                  fee: feesValue,
                  all: checkAllEvents,
                  id: currentEventEdit.id,
                  branchId: id,
                }).unwrap();
              } else {
                await createLesson({
                  ...values,
                  branchId: id,
                  id: undefined,
                  userId: values.userId,
                  roomId: values.roomId,
                  name: values.name,
                  date_start: values.startDate,
                  date_end: values.endDate,
                  startTime: values.startTime,
                  days: values.days,
                  color: values.color,
                  fees: feesValue,
                  capacity: values.capacity,
                  expectedAttendance: values.expectedAttendance,
                  duration: values.duration,
                  meeting: values.meeting,
                  all: checkAllEvents,
                }).unwrap();
              }

              // Solo si fue exitoso
              setCurrentEventEdit(undefined);
              formikHelpers.resetForm();
              setOpenDialogCreate(false);
              assistedsQuery.refetch();
              setCurrentEvent(undefined);
            } catch (error) {
              // Si hay error, mantener el formulario abierto
              console.error("Error:", error);
              // Opcionalmente mostrar un mensaje de error
              toasts.danger(
                "Error",
                "Ha ocurrido un error al guardar los datos"
              );
            }
          }}
        >
          {({
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            handleSubmit,
            errors,
            touched,
            resetForm,
            isValid,
          }) => {
            // Ensure fees is always a string when editing
            useEffect(() => {
              if (currentEventEdit && Array.isArray(currentEventEdit.fees)) {
                setFieldValue("fees", currentEventEdit.fees.join(","));
              }
            }, [currentEventEdit, setFieldValue]);

            return (
              <DialogCreate
                onClose={() => {
                  setCurrentEventEdit(undefined);
                  resetForm();
                  functionOpenDialogCreate();
                }}
                open={openDialogCreate}
                setOpen={functionOpenDialogCreate}
                tittle={
                  currentEventEdit
                    ? t("lesson.views.edit_class")
                    : t("lesson.views.new_class")
                }
                subTittle={
                  currentEventEdit ? null : t("lesson.views.creation_calendar")
                }
                tittleButtonCreate={
                  currentEventEdit ? t("general.edit") : t("general.create")
                }
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => {
                  setCurrentEventEdit(undefined);
                  resetForm();
                  functionOpenDialogCreate();
                }}
                isLoading={
                  createLessonResult.isLoading || updateLessonResult.isLoading
                }
                acceptDisabled={
                  createLessonResult.isLoading ||
                  updateLessonResult.isLoading ||
                  !isValid
                }
                cancelDisabled={
                  createLessonResult.isLoading || updateLessonResult.isLoading
                }
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.caracteristics")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.name")}
                              span={t("general.mandatory")}
                              name="name"
                              type="text"
                              placeholder={t("lesson.views.name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.name && errors.name}
                              textError={errors.name}
                              value={values.name}
                            />
                          </div>
                          <div className="col-span-full">
                            <Select
                              name="roomId"
                              tittle={t("lesson.views.room")}
                              span={t("general.mandatory")}
                              selected={roomsQuery?.data?.find(
                                (room: any) => room.id == values.roomId
                              )}
                              setSelected={(selected) =>
                                setFieldValue("roomId", selected.id)
                              }
                              options={roomsQuery?.data}
                            />
                            {errors.roomId && touched.roomId && (
                              <span className="text-red-600 text-sm">
                                {errors.roomId as string}
                              </span>
                            )}
                          </div>
                          <div className="col-span-full">
                            <SelectAvatar
                              name="userId"
                              span={t("general.mandatory")}
                              selected={specialistsQuery?.data?.find(
                                (user: any) => user.id == values.userId
                              )}
                              setSelected={(selected) =>
                                setFieldValue("userId", selected.id)
                              }
                              options={specialistsQuery?.data}
                              tittle={t("lesson.views.specialist")}
                            />
                            {errors.userId && touched.userId && (
                              <span className="text-red-600 text-sm">
                                {errors.userId as string}
                              </span>
                            )}
                          </div>
                          <div className="col-span-full">
                            {/* cuotas */}
                            <MultiSelect
                              span={t("general.optional")}
                              selectedOptions={getterFeesResult?.data?.filter(
                                (fee) =>
                                  typeof values.fees === "string" &&
                                  values.fees.split(",").includes(fee.id + "")
                              )}
                              setSelectedOptions={(selected) =>
                                setFieldValue(
                                  "fees",
                                  Array.isArray(selected)
                                    ? selected.map((fee) => fee.id).join(",")
                                    : selected.id
                                )
                              }
                              options={getterFeesResult?.data}
                              title={t("assisted.views.fees_free")}
                              textDescribe={t("assisted.views.fees_free")}
                            />
                          </div>
                          <div className="col-span-full">
                            <Select
                              name="groupId"
                              span={t("general.optional")}
                              selected={bondGroups.find(
                                (option) => +option.id === values.groupId
                              )}
                              setSelected={(selected) =>
                                setFieldValue("groupId", selected.id)
                              }
                              options={bondGroups}
                              tittle={t("assisted.views.group_bond")}
                            />
                          </div>
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <InputWithCornerHint
                              label={t("lesson.views.capacity")}
                              span={t("general.mandatory")}
                              name="capacity"
                              type="number"
                              onChange={handleChange}
                              placeholder={t("lesson.views.capacity")}
                              error={errors.capacity && touched?.capacity}
                              textError={errors?.capacity || ""}
                              value={values.capacity}
                            />
                            <div className="">
                              <SelectColor
                                span={t("general.mandatory")}
                                selected={colors.find(
                                  (option) => option?.color == values?.color
                                )}
                                setSelected={(selected) => {
                                  setFieldValue("color", selected?.color);
                                }}
                                options={colors}
                                tittle={t("lesson.views.color")}
                              />
                            </div>
                          </div>
                          <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.meeting}
                                  onChange={() => {
                                    setFieldValue("meeting", !values.meeting);
                                  }}
                                  id="meeting"
                                  name="meeting"
                                  type="checkbox"
                                  aria-describedby=""
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor="meeting"
                                  className="font-medium text-gray-900"
                                >
                                  {t("assisted.views.generate_link")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.calendaring")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <CheckBoxDays
                              onChange={(days: string[]) => {
                                const lastDay = days[days.length - 1];

                                if (values.day) {
                                  setFieldValue("day", lastDay);
                                } else {
                                  setFieldValue("days", days);
                                }
                              }}
                              value={values.day ? [values.day] : values.days}
                              error={errors.days && touched?.days}
                            />
                          </div>
                          <div className="col-span-full">
                            <DateRangePicker
                              span={t("general.mandatory")}
                              disabled={currentEventEdit && !checkAllEvents}
                              minDate={
                                currentEventEdit
                                  ? DateTime.fromFormat(
                                      values.startDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date()
                              }
                              id="date"
                              label={t("lesson.views.interval_date")}
                              value={{
                                startDate: values.startDate
                                  ? DateTime.fromFormat(
                                      values.startDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                                endDate: values.endDate
                                  ? DateTime.fromFormat(
                                      values.endDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                              }}
                              onDateChange={(startDate, endDate) => {
                                setFieldValue(
                                  "startDate",
                                  DateTime.fromJSDate(startDate).toFormat(
                                    "yyyy-MM-dd"
                                  )
                                );
                                setFieldValue(
                                  "endDate",
                                  DateTime.fromJSDate(endDate).toFormat(
                                    "yyyy-MM-dd"
                                  )
                                );
                              }}
                            />
                          </div>
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <InputWithCornerHint
                              label={t("lesson.views.time_init")}
                              span={t("general.mandatory")}
                              name="startTime"
                              type="time"
                              onChange={handleChange}
                              value={values.startTime}
                              error={errors.startTime && touched?.startTime}
                              textError={errors?.startTime || ""}
                            />
                            <InputWithCornerHint
                              label={t("lesson.views.duration")}
                              span={t("general.mandatory")}
                              name="duration"
                              type="number"
                              value={values.duration}
                              error={errors.duration && touched?.duration}
                              textError={errors?.duration || ""}
                              onChange={handleChange}
                            />
                          </div>
                          {currentEventEdit && (
                            <div className="col-span-full">
                              <div className="relative flex items-start">
                                <div className="flex h-6 items-center">
                                  <input
                                    checked={checkAllEvents}
                                    onChange={(event) =>
                                      setCheckAllEvents(event.target.checked)
                                    }
                                    name="all"
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                  />
                                </div>
                                <div className="ml-3 text-sm leading-6">
                                  <label
                                    htmlFor=""
                                    className="font-medium text-gray-900"
                                  >
                                    Este evento y los posteriores
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*FIN DIALOG NUEVA ACTIVIDAD */}

        {/*DIALOG HORAS*/}
        <Formik
          enableReinitialize
          onSubmit={(values: LessonTimesValues, formikHelpers) => {
            updateBranchHours({
              ...values,
              type: "assisteds",
              branchId: id,
            });
            functionOpenDialogTime();
          }}
          initialValues={assistedsTimesValues ?? assistedsTimesInitialValues}
          validationSchema={assistedsTimesValidationSchema}
        >
          {({ handleChange, handleSubmit, values, errors }) => (
            <DialogCreate
              onClose={() => {}}
              open={openDialogTime}
              setOpen={functionOpenDialogTime}
              tittle={t("lesson.views.hours")}
              subTittle={t("lesson.views.creation_hours")}
              tittleButtonCreate={t("general.edit")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={functionOpenDialogTime}
              isLoading={updateBranchHourssResult.isLoading}
            >
              <form action="">
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.hours")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.cancellation_time")}
                            span={t("general.mandatory")}
                            name="hours"
                            type="number"
                            placeholder=""
                            onChange={handleChange}
                            error={!!errors.hours}
                            textError={errors.hours}
                            value={values.hours}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.booking_advance")}
                            span={t("general.mandatory")}
                            id="assisted_anticipation_days"
                            name="assisted_anticipation_days"
                            type="number"
                            placeholder=""
                            onChange={handleChange}
                            error={!!errors.assisted_anticipation_days}
                            textError={errors.assisted_anticipation_days}
                            value={values.assisted_anticipation_days}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.access_time_before_min")}
                            span={t("general.mandatory")}
                            id="assisted_time_access"
                            name="assisted_time_access"
                            type="number"
                            onChange={handleChange}
                            error={!!errors.assisted_time_access}
                            textError={errors.assisted_time_access}
                            value={values.assisted_time_access}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG HORAS*/}

        {/*DIALOG CALENDARIO*/}
        <DialogCreate
          open={openDialogUpCalendar}
          setOpen={functionOpenDialogUpCalendar}
          tittle={t("lesson.views.calendar_tittle")}
          subTittle={t("lesson.views.up_calendar")}
          tittleButtonCreate={t("general.save")}
          tittleButtonCancel={t("general.cancel")}
          OnclickCreate={() => {}}
          OnclickCancel={functionOpenDialogUpCalendar}
        >
          <form action="">
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("lesson.views.calendar_tittle")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputFilepdf
                        name="pdf"
                        id="pdf"
                        label={t("lesson.views.calendar_tittle")}
                        span=""
                        spanButton={t("lesson.views.up_calendar")}
                        description={t("general.format_pdf")}
                        selectedFileName={""}
                        error={false}
                        onFileChange={() => {}}
                        onRemoveFile={() => {}}
                        tittleDelete={t("general.delete_archive")}
                      ></InputFilepdf>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </DialogCreate>
        {/*FIN DIALOG CALENDARIO*/}

        {/*MODAL TABLE FESTIVOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalFestivos}
          open={openModalFestivos}
          tittleModal={t("lesson.views.festivos")}
          functionButtonTopCreate={functionOpenDialogFestivos}
          textButtonClose={t("general.close")}
          modalClassName="z-50"
        >
          <TableListFestivos
            openModal={functionOpenDialogFestivos}
            optionsFestivos={holidaysQuery.data}
            onDelete={async (holiday) => {
              try {
                await deleteHoliday(holiday).unwrap();
                toasts.success(
                  "Eliminación exitosa",
                  "El festivo se ha eliminado correctamente"
                );
              } catch (error) {
                toasts.danger(
                  "Error al eliminar",
                  "Ha ocurrido un error al eliminar el festivo"
                );
              }
            }}
            onEdit={(holiday) => {
              setCurrentHolidayEdit({
                ...holiday,
                time_start: holiday.timeStart,
                time_end: holiday.timeEnd,
              });
              setOpenDialogFestivos(true);
            }}
          />
        </ModalXXL>
        {/*FIN MODAL TABLE FESTIVOS*/}

        {/*DIALOG FESTIVOS*/}
        <Formik
          enableReinitialize
          initialValues={currentHolidayEdit ?? holidaysInitialValues}
          validationSchema={holidaysValidationSchema}
          onSubmit={async (values, formikHelpers) => {
            try {
              if (currentHolidayEdit) {
                await updateHoliday({
                  ...values,
                  branchId: id,
                }).unwrap();
                toasts.success(
                  "Actualización exitosa",
                  "El festivo se ha actualizado correctamente"
                );
              } else {
                await createHoliday({
                  ...values,
                  branchId: id,
                }).unwrap();
                toasts.success(
                  "Registro exitoso",
                  "El festivo se ha creado correctamente"
                );
              }

              functionOpenDialogFestivos();
              formikHelpers.resetForm();
            } catch (error) {
              toasts.danger(
                "Error al actualizar",
                "Ha ocurrido un error al actualizar el festivo"
              );
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <DialogCreate
              onClose={() => setCurrentHolidayEdit(null)}
              open={openDialogFestivos}
              setOpen={functionOpenDialogFestivos}
              tittle={t("lesson.views.festivos")}
              subTittle={t("lesson.views.creation_festivos")}
              tittleButtonCreate={
                currentHolidayEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              isLoading={
                createHolidayResult.isLoading || updateHolidayResult.isLoading
              }
              acceptDisabled={
                createHolidayResult.isLoading || updateHolidayResult.isLoading
              }
              OnclickCancel={functionOpenDialogFestivos}
            >
              <form onSubmit={handleSubmit}>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.caracteristics")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.festivo")}
                            span={t("general.mandatory")}
                            id="description"
                            name="description"
                            type="text"
                            placeholder={t("lesson.views.festivo")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.description && !!errors.description}
                            textError={
                              touched.description && errors.description
                            }
                            value={values.description}
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            name="type"
                            selected={optionSelectFestivos.find(
                              (festivo) => festivo.id == values.type
                            )}
                            setSelected={(selected) =>
                              setFieldValue("type", selected.id)
                            }
                            options={optionSelectFestivos}
                            tittle={t("lesson.views.type")}
                            span={t("general.mandatory")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.calendaring")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.date")}
                            span={t("general.mandatory")}
                            id="date"
                            name="date"
                            type="date"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.date && !!errors.date}
                            textError={touched.date && errors.date}
                            value={values.date}
                          />
                        </div>
                        <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                          <InputWithCornerHint
                            label={t("lesson.views.time_init")}
                            span={t("general.mandatory")}
                            id="time_start"
                            name="time_start"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.time_start && !!errors.time_start}
                            textError={errors.time_start}
                            value={values.time_start}
                          />
                          <InputWithCornerHint
                            label={t("lesson.views.time_end")}
                            span={t("general.mandatory")}
                            id="time_end"
                            name="time_end"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.time_end && !!errors.time_end}
                            textError={errors.time_end}
                            value={values.time_end}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG FESTIVOS*/}

        {/*MODAL GRUPOS*/}
        <ModalXXL
          Close={functionOpenModalGrupos}
          open={openModalGrupos}
          tittleModal={t("lesson.views.groups")}
          textButtonClose={t("general.close")}
          modalClassName="z-50"
        >
          <TableListGrupos
            editGroups={(group) => {
              setCurrentGroupEdit(group);
              functionOpenDialogEditGrupos();
            }}
            optionsGroup={groupAssistedQuery?.data}
          />
        </ModalXXL>
        {/*FIN MODAL GRUPOS*/}

        {/*DIALOG EDIT GRUPOS*/}
        <Formik
          enableReinitialize
          onSubmit={async (values, formikHelpers) => {
            try {
              const formData = new FormData();
              formData.append("file", values.file);
              formData.append("description", values.description);
              formData.append(
                "group",
                currentGroupEdit ? currentGroupEdit?.name : ""
              );
              formData.append("color", currentGroupEdit.color);

              await updateAssistedGroup({
                formData,
                branchId: id,
              }).unwrap();
              setOpenDialogEditGrupos(false);
              formikHelpers.resetForm();
              assistedsQuery.refetch();
              toasts.success(
                "Grupo actualizado",
                "El grupo se ha actualizado correctamente"
              );
              functionOpenModalGrupos();
              groupAssistedQuery.refetch();
            } catch (error) {
              console.log(error);
              toasts.danger(
                "Error al actualizar",
                "Ha ocurrido un error al actualizar el grupo"
              );
            }
          }}
          initialValues={{
            description: currentGroupEdit ? currentGroupEdit?.description : "",
            file: currentGroupEdit?.pathFileImage
              ? `${DOMAIN}/${currentGroupEdit.pathFileImage}`
              : undefined,
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            setFieldValue,
            resetForm,
          }) => {
            return (
              <DialogCreate
                isLoading={updateAssistedGroupResult.isLoading}
                onClose={() => {
                  functionOpenDialogEditGrupos();
                  resetForm();
                }}
                open={openDialogEditGrupos}
                setOpen={functionOpenDialogEditGrupos}
                tittle={t("lesson.views.group")}
                subTittle={t("lesson.views.edit_group")}
                tittleButtonCreate={t("general.edit")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => {
                  functionOpenDialogEditGrupos();
                  resetForm();
                }}
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.groups")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputFile
                              id="file"
                              name="file"
                              label={t("lesson.views.thumbnail")}
                              span={t("general ")}
                              spanButton={t("general.up_image")}
                              description={t("general.format_image")}
                              selectedImage={values.file}
                              error={!!errors.file}
                              onFileChange={(file) =>
                                setFieldValue("file", file)
                              }
                              onRemoveImage={() => {}}
                              tittleDelete={t("general.delete_image")}
                            />
                            <p className="text-sm text-gray-400 mt-1 text-center">
                              {t("lesson.views.thumbnail_description")}
                            </p>
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.description")}
                              span=""
                              id=""
                              name="description"
                              type="text"
                              placeholder={t("lesson.views.description")}
                              onChange={handleChange}
                              error={!!errors.description}
                              textError={errors.description}
                              value={values.description}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*DIALOG EDIT GRUPOS */}

        {/*DIALOG CREATE GRUPOS */}
        <DialogCreate
          open={openDialogCreateGrupos}
          setOpen={functionOpenDialogCreateGrupos}
          tittle={t("slots.views.slot_group")}
          subTittle={t("slot.views.create_slot_group")}
          tittleButtonCreate={t("general.create")}
          tittleButtonCancel={t("general.cancel")}
          OnclickCreate={() => {}}
          OnclickCancel={functionOpenDialogCreateGrupos}
        >
          <form action="">
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("slots.views.group")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("slots.views.name")}
                        span=""
                        id=""
                        name=""
                        type="text"
                        placeholder={t("slots.views.name")}
                        onChange={() => {}}
                        error={false}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("slots.views.description_edit")}
                        span=""
                        id=""
                        name=""
                        type="text"
                        placeholder={t("slots.views.description_edit")}
                        onChange={() => {}}
                        error={false}
                      />
                    </div>
                    <div className="col-span-full">
                      <SelectColor
                        selected={selectColor}
                        setSelected={setSelectColor}
                        options={optionColor}
                        tittle={t("slots.views.color")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("slots.views.slots_from_group")}
                        span=""
                        id=""
                        name=""
                        type="text"
                        placeholder={t("slots.views.slots_from_group")}
                        onChange={() => {}}
                        error={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </DialogCreate>
        {/*FIN DIALOG CREATE GRUPOS */}

        {/*MODAL TABLE BONOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalBonos}
          open={openModalBonos}
          tittleModal={t("slots.views.bonds")}
          functionButtonTopCreate={functionOpenDialogCreateBonos}
          textButtonClose={t("general.close")}
          canCreate={can(
            Permission.BRANCH_ACCESS_CREATE_EDIT_PROFESSIONAL_SERVICE_BONUSES
          )}
          modalClassName="z-50"
        >
          <TableListBonos
            bonos={listBondModalQuery?.data || []}
            functionButtonPause={handleActivateDeactivateBond}
            functionButtonEdit={(bond: any) => {
              toasts.warning(
                "Bonos de servicios profesionales",
                "¿Estás seguro de que quieres modificarla? Esto afectará de inmediato a todos los usuarios a los que se les haya asignado esta cuota, y los próximos cobros podrían verse afectados"
              );
              setCurrentBondEdit({ ...bond });
              functionOpenDialogCreateBonos();
            }}
            canPause={can(
              Permission.BRANCH_ACCESS_PAUSE_DEPAUSE_PROFESSIONAL_SERVICE_BONUSES
            )}
          />
        </ModalXXL>
        {/*FIN MODAL TABLE BONOS*/}

        {/*DIALOG CREATE BONOS */}
        <Formik
          enableReinitialize
          validationSchema={bondValidationSchema}
          initialValues={
            currentBondEdit
              ? {
                  ...currentBondEdit,
                  currency: currentBondEdit?.currency || "EUR",
                  groupBondId: currentBondEdit?.groupbond_id || null,
                }
              : bondInitialValues
          }
          onSubmit={async (
            values: CreateBondValues,
            formikHelpers: FormikHelpers<CreateBondValues>
          ) => {
            try {
              if (currentBondEdit) {
                await handleUpdateBond(values);
                setCurrentBondEdit(undefined);
                formikHelpers.resetForm();
                functionOpenDialogCreateBonos();
                functionOpenModalBonos();
                listBondModalQuery.refetch();
              } else {
                await handleCreateBond(values);
                formikHelpers.resetForm();
                functionOpenDialogCreateBonos();
                functionOpenModalBonos();
                listBondModalQuery.refetch();
              }
            } catch (error) {
              console.log("Error", error);
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            setFieldValue,
            resetForm,
            touched,
          }) => (
            <DialogCreate
              open={openDialogCreateBonos}
              setOpen={functionOpenDialogCreateBonos}
              tittle={t("slots.views.bond")}
              subTittle={t("slots.views.create_bond")}
              tittleButtonCreate={
                currentBondEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                functionOpenDialogCreateBonos();
                resetForm();
              }}
              isLoading={
                createBondResult.isLoading || updateBondResult.isLoading
              }
              acceptDisabled={
                createBondResult.isLoading || updateBondResult.isLoading
              }
              onClose={() => {
                setCurrentBondEdit(null);
                functionOpenDialogCreateBonos();
                resetForm();
              }}
            >
              <div>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.caracteristics")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("slots.views.name")}
                            span={t("general.mandatory")}
                            name="name"
                            type="text"
                            placeholder={t("slots.views.name")}
                            onChange={handleChange}
                            value={values.name}
                            error={!!errors.name}
                            textError={errors.name}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("slots.views.description_edit")}
                            span={t("general.optional")}
                            name="description"
                            type="text"
                            placeholder={t("slots.views.description_edit")}
                            onChange={handleChange}
                            value={values.description}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.price")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputDropDownSpan
                            label={t("slots.views.price")}
                            span={t("general.mandatory")}
                            name="price"
                            type="number"
                            placeholder={t("slots.views.price")}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value);
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: isNaN(value) ? "" : value,
                                },
                              });
                            }}
                            value={values.price}
                            nameSelect="currency"
                            selectValue={values.currency.toUpperCase()}
                            onSelectChange={handleChange}
                            options={currencies.map((item) => ({
                              ...item,
                              id: item.currency,
                              text: item.currency,
                            }))}
                            error={
                              (touched.price && !!errors.price) ||
                              (touched.currency && !!errors.currency)
                            }
                            textError={
                              (touched.price && errors.price) ||
                              (touched.currency && errors.currency)
                            }
                          />
                        </div>

                        {!values.checkedBonos && (
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.has_access_general}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "has_access_general",
                                      e.target.checked
                                    )
                                  }
                                  name="has_access_general"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label className="font-medium text-gray-900">
                                  {t("slots.views.checkBonoCenter")}
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                          {!values.checkedBonos && (
                            <div className="mt-6 col-span-full">
                              <InputWithCornerHint
                                label={t("slots.views.session")}
                                span={t("general.mandatory")}
                                name="session"
                                type="number"
                                placeholder=""
                                onChange={handleChange}
                                value={values.session}
                                error={errors?.session && touched?.session}
                                textError={errors?.session}
                              />
                            </div>
                          )}
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("slots.views.days_caducity_description")}
                              span={t("general.optional")}
                              name="daysCaducity"
                              type="number"
                              placeholder=""
                              onChange={handleChange}
                              value={values.daysCaducity}
                              error={
                                errors?.daysCaducity && touched?.daysCaducity
                              }
                              textError={errors?.daysCaducity}
                            />
                          </div>
                        </div>
                        {!values.checkedBonos && !values.has_access_general && (
                          <div className="col-span-full grid grid-cols-1 place-content-center">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.checkedAcumular}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "checkedAcumular",
                                      e.target.checked
                                    )
                                  }
                                  name="checkedAcumular"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label className="font-medium text-gray-900">
                                  {t("slots.views.session_acum")}
                                </label>
                              </div>
                            </div>
                            {values.checkedAcumular && (
                              <div className="full-span">
                                <InputWithCornerHint
                                  label={t("slots.views.max_session")}
                                  name="maxSession"
                                  type="number"
                                  placeholder=""
                                  onChange={handleChange}
                                  value={values.maxSession}
                                  error={!!errors.maxSession}
                                  textError={errors.maxSession}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    {!values.checkedBonos && (
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 ">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("slots.views.group_bond")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full grid grid-cols-1 sm:grid-cols-2 gap-6 items-center">
                            <div className="col-span-full">
                              <InputWithCornerHint
                                label={t("slots.views.write_bond")}
                                span={t("general.optional")}
                                name="name_group_bond"
                                type="text"
                                placeholder=""
                                onChange={handleChange}
                                value={values.name_group_bond}
                                error={
                                  errors?.name_group_bond &&
                                  touched?.name_group_bond
                                }
                                textError={errors?.name_group_bond}
                              />
                            </div>
                            <div className="col-span-full flex items-center justify-center text-gray-900 font-semibold">
                              <div className="flex-grow border-t border-gray-300"></div>
                              <span className="px-4 text-gray-400 text-lg ">
                                {t("slots.views.o")}
                              </span>
                              <div className="flex-grow border-t border-gray-300"></div>
                            </div>
                            <div className="col-span-full">
                              <Select
                                name="groupBondId"
                                disabled={values.name_group_bond}
                                span={
                                  values.name_group_bond
                                    ? t("general.optional")
                                    : t("general.mandatory")
                                }
                                selected={bondGroups.find(
                                  (option) => +option.id === values.groupBondId
                                )}
                                setSelected={(selected) => {
                                  console.log("selected", selected);
                                  setFieldValue(
                                    "groupBondId",
                                    Number(selected.id)
                                  );
                                }}
                                options={bondGroups}
                                tittle={t("slots.views.select_group_bond")}
                                error={!!errors.groupBondId}
                                textError={errors.groupBondId}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG CREATE BONOS */}

        {/*MODAL SALAS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalSala}
          open={openModalSala}
          tittleModal={t("lesson.views.rooms")}
          functionButtonTopCreate={functionOpenDialogSala}
          textButtonClose={t("general.close")}
          canCreate={can(
            Permission.BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_PROFESSIONAL_SERVICES
          )}
          modalClassName="z-50"
        >
          <TableListSalas
            optionsSalas={roomsQuery?.data}
            onDelete={(room) => deleteRoom(room)}
            onEdit={(room) => {
              setCurrentRoomEdit(room);
              functionOpenDialogSala();
            }}
            canEdit={can(
              Permission.BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_PROFESSIONAL_SERVICES
            )}
          />
        </ModalXXL>
        {/*FIN MODAL SALAS*/}

        {/*DIALOG CREATE SALAS */}
        <Formik
          enableReinitialize
          validationSchema={createRoomValidationSchema}
          initialValues={currentRoomEdit ?? createRoomInitialValues}
          onSubmit={async (values: CreateRoomValues, formikHelpers) => {
            try {
              if (currentRoomEdit) {
                await handleUpdateRoom(values);
                setCurrentRoomEdit(undefined);
                formikHelpers.resetForm();
              } else {
                await handleCreateRoom(values);
                setCurrentRoomEdit(undefined);
                formikHelpers.resetForm();
              }
            } catch (error) {
              console.error(error);
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            setFieldValue,
            resetForm,
            touched,
          }) => (
            <DialogCreate
              onClose={() => {
                setCurrentRoomEdit(undefined);
                resetForm();
              }}
              open={openDialogSala}
              setOpen={functionOpenDialogSala}
              tittle={
                currentRoomEdit
                  ? t("lesson.views.edit_rooms")
                  : t("lesson.views.directed_activities_rooms")
              }
              subTittle={
                currentRoomEdit ? null : t("lesson.views.creating_rooms")
              }
              tittleButtonCreate={
                currentRoomEdit ? t("general.edit") : t("general.create")
              }
              isLoading={
                createRoomResult.isLoading || updateRoomResult.isLoading
              }
              acceptDisabled={
                createRoomResult.isLoading || updateRoomResult.isLoading
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                setCurrentRoomEdit(undefined);
                resetForm();
              }}
            >
              <form action="">
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.rooms")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.name")}
                            span={t("general.mandatory")}
                            id="name"
                            name="name"
                            type="text"
                            placeholder={t("lesson.views.name")}
                            onChange={handleChange}
                            value={values.name}
                            error={errors.name && touched.name}
                            textError={errors.name}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.description")}
                            span={t("general.mandatory")}
                            id="description"
                            name="description"
                            type="text"
                            placeholder={t("lesson.views.description")}
                            onChange={handleChange}
                            value={values.description}
                            error={errors.description && touched.description}
                            textError={errors.description}
                          />
                        </div>
                        <div className="col-span-full">
                          <SelectColor
                            options={colors}
                            span={t("general.optional")}
                            tittle={t("lesson.views.color")}
                            selected={colors.find(
                              (option) => option?.color == values?.color
                            )}
                            setSelected={(selected) => {
                              setFieldValue("color", selected?.color);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG CREATE SALAS */}

        {/*MODAL KPIS*/}
        <ModalXXL
          Close={handleOpenKpis}
          open={openKpis}
          tittleModal={t("assisted.views.kpis")}
          textButtonClose={t("general.close")}
          textButtonCreate={t("general.clear")}
          onClickCreate={handleClearKpis}
          modalClassName="z-50"
        >
          <form className="flex flex-col lg:flex-row gap-4 justify-center items-center w-full">
            <div className="col-span-full max-w-xs">
              <MultiSelect
                options={bondGroups}
                selectedOptions={selectBonosModal}
                setSelectedOptions={setSelectBonosModal}
                title={t("assisted.views.bond_group")}
              />
            </div>
            <div className="col-span-full">
              <DateRangePicker
                id="fechaKPIS"
                label={t("assisted.views.interval_date")}
                value={{
                  startDate: startDateKPIProfessionalServices
                    ? DateTime.fromFormat(
                        startDateKPIProfessionalServices,
                        "dd/MM/yyyy"
                      ).toJSDate()
                    : new Date(),
                  endDate: endDateKPIProfessionalServices
                    ? DateTime.fromFormat(
                        endDateKPIProfessionalServices,
                        "dd/MM/yyyy"
                      ).toJSDate()
                    : new Date(),
                }}
                onDateChange={(startDate, endDate) => {
                  setStartDateKPIProfessionalServices(
                    DateTime.fromJSDate(startDate).toFormat("dd/MM/yyyy")
                  );
                  setEndDateKPIProfessionalServices(
                    DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd")
                  );
                }}
              />
            </div>
          </form>
          <TableListKPIS
            optionsKPIS={dataKpiProfessionalServicesQuery?.data ?? []}
          />
        </ModalXXL>
        {/*FIN MODAL KPIS */}

        {/*MODAL XXL*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={() => setCurrentEvent(undefined)}
          open={!!currentEvent}
          tittleModal={t("lesson.views.activity")}
          textButtonClose={t("general.close")}
          functionButtonTopCreate={functionOpenModalEnrollUserActivity}
          functionButtonDelete={() => {
            functionOpenModalDeleteEvent();
          }}
          functionButtonEdit={() => {
            setCurrentEventEdit(currentEvent);
          }}
          canEdit={can(Permission.BRANCH_ACCESS_EDIT_PROFESSIONAL_SERVICES)}
          canDelete={can(Permission.BRANCH_ACCESS_DELETE_PROFESSIONAL_SERVICES)}
        >
          <div className="flex flex-col sm:flex-row">
            {/* Columna Izquierda */}
            <div className="w-full sm:w-1/2 p-4">
              <div>
                <div className="px-4 sm:px-0">
                  <h3 className="text-base font-semibold leading-7 text-gray-900">
                    {currentEvent?.name}
                  </h3>
                  <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                    {currentEvent?.description}
                  </p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                  <dl className="divide-y divide-gray-100">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.ocupation")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.expectedAttendance}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.date_duration")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.date} ({currentEvent?.duration} min)
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.specialist")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.user?.name}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.room")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.roomName}
                      </dd>
                    </div>
                    {currentEvent?.meeting && (
                      <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt className="text-sm font-medium leading-6 text-gray-900">
                          {t("lesson.views.link_meeting")}
                        </dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Ir a la reunión"
                            to={`https://meet.google.com/${currentEvent?.link_meeting?.split("/")?.pop()}`}
                            className="text-blue-500 hover:text-blue-600"
                          >
                            {currentEvent?.link_meeting}
                          </Link>
                        </dd>
                      </div>
                    )}
                  </dl>
                </div>
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="w-full sm:w-1/2 p-4">
              <TableListUsersActivitys
                users={currentEvent?.reservations?.map(({ user }) => user)}
                onClickEmpty={functionOpenModalEnrollUserActivity}
              />
            </div>
          </div>
        </ModalXXL>
        {/*FIN MODAL XXL */}

        {/*MODAL DELETE EVENT XXL*/}
        <Modal
          Close={functionOpenModalDeleteEvent}
          open={openModalDeleteEvent}
          tittleModal={""}
          onClickCreate={handleDeleteLessonProfessionalService}
          loader={deleteLessonProfessionalServiceResult.isLoading}
          disabledCreated={deleteLessonProfessionalServiceResult.isLoading}
          textButtonCreate={t("general.delete")}
          textButtonClose={t("general.close")}
        >
          <div>
            <h2 className="text-2xl font-semibold">Cuidado</h2>
            <div className="mt-4 ">
              <p>
                Si deseas eliminar todos los eventos posteriores que pertenecen
                a esta mismo servicio profesional
              </p>
            </div>
            <div className="mt-4 flex items-center gap-2">
              <label
                className="flex items-center cursor-pointer select-none"
                htmlFor="deleteAllEventsCheckbox"
              >
                <Input
                  id="deleteAllEventsCheckbox"
                  checked={deleteAllEvents}
                  onChange={() => setDeleteAllEvents(!deleteAllEvents)}
                  type="checkbox"
                  className="flex"
                  label=""
                  aria-checked={deleteAllEvents}
                />
                <span className="ml-2">
                  Eliminar este evento y los posteriores
                </span>
              </label>
            </div>
          </div>

          <div className="mt-4">
            <span>Está seguro que desea eliminar?</span>
          </div>
        </Modal>

        {/* MODAL ENROLL USER SP XXL */}
        <Formik
          initialValues={{
            user: null,
            all: false,
          }}
          validationSchema={Yup.object({
            user: Yup.string()
              .min(1, FIELD_REQUIRED_MESSAGE)
              .required(FIELD_REQUIRED_MESSAGE),
          })}
          validateOnMount={false}
          onSubmit={async (values, formikHelpers) => {
            try {
              await handleEnrollUserActivity(values);
              formikHelpers.resetForm();
            } catch (error) {
              console.log(error);
              functionOpenModalEnrollUserActivity();
              formikHelpers.resetForm();
            }
          }}
        >
          {({
            handleSubmit,
            isValid,
            values,
            errors,
            touched,
            handleBlur,
            resetForm,
            setFieldValue,
          }) => {
            return (
              <Modal
                Close={() => {
                  functionOpenModalEnrollUserActivity();
                  resetForm();
                }}
                open={openModalEnrollUserActivity}
                tittleModal={"Agregar usuario"}
                textButtonClose={t("general.close")}
                textButtonCreate={t("general.save")}
                onClickCreate={handleSubmit}
                disabledCreated={enrollUserAssistedResult.isLoading || !isValid}
                loader={enrollUserAssistedResult.isLoading}
              >
                <div>
                  <div className="col-span-full grid grid-cols-1 place-content-center mt-4">
                    <InputWithSelectHint
                      name="user"
                      tittle={t("lesson.views.enroll_user_activity")}
                      span={t("general.mandatory")}
                      setSelected={(user) => {
                        setFieldValue("user", user?.id);
                      }}
                      selected={users.find((user) => user.id === values.user)}
                      type="text"
                      value={values.user}
                      onQueryChange={(search) =>
                        debouncedFetchDataUsers(search)
                      }
                      options={users}
                      error={errors.user && (touched.user as boolean)}
                      textError={errors.user as string}
                    />
                  </div>

                  <div className="col-span-full mt-3">
                    <div className="relative flex items-start">
                      <div className="flex h-6 items-center">
                        <input
                          id="all"
                          checked={values.all}
                          onChange={(event) =>
                            setFieldValue("all", event.target.checked)
                          }
                          name="all"
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="ml-3 text-sm leading-6">
                        <label
                          htmlFor="all"
                          className="font-medium text-gray-900"
                        >
                          Este evento y los posteriores
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            );
          }}
        </Formik>
      </div>
      {filters ? (
        <>
          <FiltersCalendar
            filtersOpen={filtersOpen}
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups as any}
            options={groupAssistedQuery?.data}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
